/* eslint-disable prefer-rest-params */
import { AxiosResponse } from 'axios';
import { API_ROUTES } from '../../../constants/app';
import { Command } from '../../../types/commands';
import axios, { handleUnauthorized } from '../../axios';
import { ColorCode, ColorValuesShown, WIDGET_TYPE } from '../../../types';

export async function addNewColorPaletteWidgetToSectionApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  widgetType: WIDGET_TYPE.COLOR_PALETTE,
  columnIndex: number,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.ADD_NEW_COLOR_PALETTE_WIDGET_TO_SECTION,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        widgetType,
        columnIndex,
      },
    })
    .catch(error =>
      handleUnauthorized(
        error,
        addNewColorPaletteWidgetToSectionApi,
        ...arguments,
      ),
    );
}

export async function addColorToColorWidgetApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  widgetColorName: string,
  widgetColorCodes: ColorCode[],
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.ADD_NEW_COLOR_TO_COLOR_PALETTE_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        columnIndex,
        widgetId,
        widgetColorName,
        widgetColorCodes,
      },
    })
    .catch(error =>
      handleUnauthorized(error, addColorToColorWidgetApi, ...arguments),
    );
}

export async function removeColorFromColorWidgetApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  widgetColorPosition: number,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.REMOVE_COLOR_FROM_COLOR_PALETTE_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        widgetColorPosition,
      },
    })
    .catch(error =>
      handleUnauthorized(error, removeColorFromColorWidgetApi, ...arguments),
    );
}

export async function editColorInColorWidgetApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  widgetColorName: string,
  widgetColorCodes: ColorCode[],
  widgetColorPosition: number,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_COLOR_IN_COLOR_PALETTE_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        widgetColorName,
        widgetColorCodes,
        widgetColorPosition,
      },
    })
    .catch(error =>
      handleUnauthorized(error, editColorInColorWidgetApi, ...arguments),
    );
}
export async function setDefaultColorCodesInColorPaletteWidgetApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  colorValuesShown: ColorValuesShown,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.SET_DEFAULT_COLOR_CODES_IN_COLOR_PALETTE_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        widgetDefaultColorCodes: colorValuesShown,
      },
    })
    .catch(error =>
      handleUnauthorized(
        error,
        setDefaultColorCodesInColorPaletteWidgetApi,
        ...arguments,
      ),
    );
}
export async function editColorPaletteStyleApi(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  stylesheet: string,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_STYLE_IN_COLOR_PALETTE_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        style: { stylesheet, language: 'css', version: 3 },
      },
    })
    .catch(error =>
      handleUnauthorized(error, editColorPaletteStyleApi, ...arguments),
    );
}
